import { tv } from "tailwind-variants";

const pageContainer = tv({
  base: "flex min-w-0 flex-col items-stretch gap-8 overflow-y-auto px-16 py-8",
  variants: {
    withPageHeader: {
      true: "h-[calc(100%-(var(--spacing)*16))]",
      false: "h-full",
    },
  },
  defaultVariants: {
    withPageHeader: true,
  },
});

export default function PageContainer({
  children,
  className,
  ref,
  withPageHeader = true,
}: Readonly<{
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
  withPageHeader?: boolean;
}>) {
  return (
    <div
      id="page-content"
      className={pageContainer({ withPageHeader, className })}
      ref={ref}
    >
      {children}
    </div>
  );
}
